import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as NotificationsActions from "../../actions/notificationsActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const loadNotificationsLogic = createLogic({
	type: ActionTypes.LOAD_NOTIFICATIONS,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());

		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/apps/${action.appKey}/notifications`)
					.then(res => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(NotificationsActions.loadNotificationsSuccess(res.data));
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.hideLoading());
						dispatch(NotificationsActions.loadNotificationsFail(error));
						done();
					});
			});
	},
});

export default [loadNotificationsLogic];
